import { State } from '../../../store/state';

export const userSelector = (state: State) => state.me.user;
export const timezoneSelector = (state: State) => state.me.timezone;
export const profesorCoursesSelector = (state: State) => state.me.profesorCourses;
export const studentCoursesSelector = (state: State) => state.me.studentCourses;
export const isGoogleSyncedSelector = (state: State) => state.me.isGoogleSynced;
export const errorCodeSelector = (state: State) => state.me.errorCode;
export const googleStatusSelector = (state: State) => state.me.googleStatus;
